import { useTranslation } from 'react-i18next'
import { Errors } from 'config'

export type AuthErrorKeys = Partial<Record<Errors, string>>

const UNKNOWN_AUTH_ERROR_KEY = 'authErrors.unknown'

// Codes not listed get the generic message, so a screen never shows a raw code,
// e.g. on a Firebase outage. Account codes (user not found, user disabled)
// only make sense on screens with an email field, so those screens map them.
const AUTH_ERROR_KEYS: AuthErrorKeys = {
  [Errors.NetworkRequestFailed]: 'authErrors.network',
  [Errors.ExpiredActionCode]: 'authErrors.invalidLink',
  [Errors.InvalidActionCode]: 'authErrors.invalidLink',
  [Errors.InvalidEmail]: 'authErrors.invalidEmail',
  [Errors.AuthEmailNotFound]: 'authErrors.emailNotFound',
  [Errors.InvalidDeviceContext]: 'authErrors.invalidDeviceContext',
  [Errors.WeakPassword]: 'authErrors.weakPassword',
  [Errors.WrongPassword]: 'authErrors.wrongCredentials',
  // Reported instead of a wrong password or a missing user when email
  // enumeration protection is on
  [Errors.InvalidCredential]: 'authErrors.wrongCredentials',
  [Errors.TooManyRequests]: 'authErrors.tooManyRequests',
  [Errors.AccountNotActivated]: 'authErrors.accountNotActivated',
}

export const useMapAuthError = (overrides: AuthErrorKeys = {}) => {
  const { t } = useTranslation()

  const mapError = (error: string) =>
    t(
      overrides[error as Errors] ??
        AUTH_ERROR_KEYS[error as Errors] ??
        UNKNOWN_AUTH_ERROR_KEY
    )

  return { mapError }
}
